﻿import { Tooltip as MuiTooltip, TooltipProps } from "@material-ui/core";
import React, { FunctionComponent, ReactElement } from "react";

// TODO: remove this lint disable and fix
// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ITooltipProps extends TooltipProps {}

export const Tooltip: FunctionComponent<ITooltipProps> = (
    props,
): ReactElement => {
    const { children, ...otherProps } = props;

    return <MuiTooltip {...otherProps}>{children}</MuiTooltip>;
};
